import React from 'react';
import { useHistory } from 'react-router-dom';
import { Box, IconButton, Tooltip } from '@mui/material';
import FeedIcon from '@mui/icons-material/Feed';
import { useDispatch } from 'react-redux';
import { useTheme } from '@mui/system';
import trackUse from '@utils/trackUse';
import { VariationType } from '@types';
import { dealsAction } from '@actions/index';
import { formatPrice, logPostHogEvent } from '@utils/index';

const VariationPrice = (variation: VariationType) => {
  const history = useHistory();
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const dispatch = useDispatch();
  const { prime, amount, listPrice, hasDealInDb } = variation;
  const isPrime = prime === 1;

  const renderListPrice = () => {
    const finalPriceTotal = amount / 100;
    if (!listPrice || listPrice === amount || listPrice < finalPriceTotal) {
      return null;
    }

    return (
      <Box
        sx={{
          margin: '0',
          '@media (max-width: 48rem)': {
            display: 'block'
          }
        }}
        component="span"
      >{` (reg. ${formatPrice(listPrice)})`}</Box>
    );
  };

  const isShowingDbPrice =
    hasDealInDb && hasDealInDb.finalPrice && hasDealInDb.slug;

  return (
    <Box>
      {isPrime ? (
        <Box
          sx={{
            margin: 'auto',
            fontStyle: 'italic',
            fontWeight: 700,
            color: '#1ba4d8'
          }}
        >
          Prime
        </Box>
      ) : null}
      {formatPrice(amount / 100)}
      {renderListPrice()}
      {isShowingDbPrice ? (
        <Box display="flex" justifyContent="left">
          <Tooltip title="See deal details">
            <IconButton
              size="small"
              onClick={() => {
                trackUse({
                  item: `variation-slug-click`,
                  value: hasDealInDb.slug,
                  type: 'CLICK'
                });

                logPostHogEvent('variation-slug-deal-database-exists-click', {
                  value: !hasDealInDb?.slug,
                  type: 'CLICK'
                });

                dispatch(dealsAction.getBlogSEO(hasDealInDb.slug));
                history.push(`/blog/${hasDealInDb.slug}`);
              }}
              sx={{
                marginTop: '4px'
              }}
            >
              <FeedIcon
                sx={{
                  color: isDarkMode ? theme.palette.linkColor : '#4a148c'
                }}
              />
            </IconButton>
          </Tooltip>
        </Box>
      ) : null}
    </Box>
  );
};

export default VariationPrice;
